---
title: Privacy Policy
lastUpdated: 31 July 2026
lead: What we collect when you join the Tiny Boss waitlist, and what we never do with it.
---

## The Short Version

Tiny Boss is currently in early access. This site's only job is to collect
your email address so we can invite you when a spot opens up. We don't run
ads, we don't track you across the web, and we don't sell your information
to anyone — ever.

## Information We Collect

The only personal information we collect through this site is the email
address you give us when you join the waitlist. We don't ask for your name,
your child's name, or anything about your family to sign up.

Like most web hosts, our hosting provider (Cloudflare) automatically logs
basic technical information for every request — things like IP address and
browser type — for security and reliability. We don't use this to build a
profile of you, and this site does not use cookies or analytics scripts.

## How We Use Your Information

We use your email address to:

- Let you know when early access opens up
- Send occasional updates about Tiny Boss before launch
- Respond if you email us directly

That's it. We won't use your email for anything beyond keeping you posted
on Tiny Boss.

## Who We Share It With

We use a third-party email service provider to manage the waitlist and send
messages on our behalf. That provider only has access to what's needed to
do that job — your email address — and is bound to use it solely for
sending our messages, not their own purposes.

We don't sell, rent, or trade your information to anyone, for any reason.

## How Long We Keep It

We keep your email address for as long as you're on the waitlist. If you
unsubscribe or ask us to delete it, we'll remove it from our active list
and our email provider within a reasonable time.

## Children's Privacy

This site is intended for use by adults signing up on their own behalf.
We do not knowingly collect any information about children through this
site, and we don't ask for or store any information about your child to
join the waitlist.

## Your Choices

Every email we send includes an unsubscribe link. You can also email us
directly at [hey@tinybossapp.com](mailto:hey@tinybossapp.com) to unsubscribe
or ask us to delete your information, and we'll take care of it.

## Security

We take reasonable steps to protect the information you share with us, but
no method of transmission or storage is 100% secure, and we can't guarantee
absolute security.

## Changes to This Policy

If how we collect or use your information changes in a meaningful way,
we'll update this page and change the date at the top. This policy will be
rewritten once Tiny Boss the app is available and handles more than a
waitlist signup.

## Questions?

Reach us any time at [hey@tinybossapp.com](mailto:hey@tinybossapp.com).
